module.exports = fox._r("css/slick/ajax-loader.gif", __webpack_public_path__ + "_/_/_/main/css/slick/ajax-loader.gif");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/main/css/slick/ajax-loader.gif
// module id = 133
// module chunks = 4